import React from 'react';
import Section from '../components/Section';
import ChipSelect from '../components/ChipSelect';
import TextField from '../components/TextField';

// "Nothing ran out" tag removed — replaced by mandatory free-text field below
const INGREDIENT_OPTIONS = [
  'Brown sugar',
  'Tapioca pearls',
  'Tea base',
  'Milk',
  'Toppings',
  'Cups or lids',
  'Straws',
  'Packaging',
];

function S4_Ingredients({ data, onChange, errors }) {
  return (
    <Section title="Ingredients and stock">
      <ChipSelect
        label="Did we run out of anything today?"
        options={INGREDIENT_OPTIONS}
        selected={data.ingredient_issues || []}
        onChange={(v) => onChange('ingredient_issues', v)}
      />

      {/* MODIFIED — mandatory free-text replaces "Nothing ran out" tag */}
      <TextField
        label="Stock issues (type 'None' if nothing ran out)"
        value={data.stock_issues_text || ''}
        onChange={(v) => onChange('stock_issues_text', v)}
        multiline
        maxLength={300}
        required
        hasError={!!errors.stock_issues_text}
        errorMsg={errors.stock_issues_text}
        placeholder="e.g. None — or — Ran out of tapioca pearls at 7pm, affected ~8 orders"
      />

      <TextField
        label="Any other details?"
        value={data.ingredient_notes || ''}
        onChange={(v) => onChange('ingredient_notes', v)}
        multiline
        maxLength={200}
        placeholder="Optional — e.g. what time, how many orders affected"
      />
    </Section>
  );
}

export default S4_Ingredients;
